import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import {
  API_ENDPOINTS,
  AddReviewParams,
  ProductAddReviewRequest,
  ProductListReviewItem,
  ProductListReviewRequest,
  ProductListReviewResponse,
  ReviewsInfo,
  ReviewsInfoResponse,
} from '@reviews/const';
import { PRODUCT_LIST_REVIEW_NORMALIZER, REVIEWS_NORMALIZER } from '@reviews/utils';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductReviewsApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
  ) {}

  load(productCode: string): Observable<ReviewsInfo> {
    const url = this.occEndpointsService.buildUrl(
      API_ENDPOINTS.load,
      {
        urlParams: { productSku: productCode },
      },
      { prefix: false, baseSite: false },
    );

    return this.http
      .get<ReviewsInfoResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.load),
      })
      .pipe(this.converterService.pipeable(REVIEWS_NORMALIZER));
  }

  loadProductList(productCodes: string[]): Observable<ProductListReviewItem[]> {
    const url = this.occEndpointsService.buildUrl(
      API_ENDPOINTS.loadProductList,
      {},
      { prefix: false, baseSite: false },
    );
    const body = <ProductListReviewRequest>{
      productSkus: productCodes,
    };

    return this.http
      .post<ProductListReviewResponse>(url, body, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.loadProductList),
      })
      .pipe(
        map((response) => response.data.items),
        this.converterService.pipeableMany(PRODUCT_LIST_REVIEW_NORMALIZER),
      );
  }

  add(params: AddReviewParams): Observable<unknown> {
    const { name, email, pros, cons, reviewText, rate, product } = params;
    const url = this.occEndpointsService.buildUrl(
      API_ENDPOINTS.add,
      {
        urlParams: { productSku: product.code },
      },
      { prefix: false, baseSite: false },
    );

    const body = <ProductAddReviewRequest>{
      AuthorName: name,
      AuthorEmail: email,
      Recommends: true,
      ReviewText: reviewText,
      Pros: pros,
      Cons: cons,
      Rate: rate,
      ProductName: product.name,
      ProductURL: product.url,
    };

    return this.http.post(url, body, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.add),
    });
  }
}
